import { ApiRoutes, AppRoutes } from '../helpers/routes'
import { sleep } from '../helpers/utils'
import { FetchResponse } from '../models/shared'

const fetchApi = async (input: string | URL | globalThis.Request, init?: RequestInit) => {
    try {
        const token = localStorage.getItem('_auth')
        const headers = new Headers(init?.headers)
        const isFormData = init?.body instanceof FormData

        if (!headers.get('Content-Type') && !isFormData) {
            headers.set('Content-Type', 'application/json')
        }

        if (!headers.get('Authorization') && token) {
            headers.set('Authorization', `Bearer ${token}`)
        }

        const response = await fetch(input, { ...init, headers })

        if (response.ok) {
            let data = null
            const isJsonResponse = response.headers
                .get('Content-Type')
                ?.includes('application/json')

            if (isJsonResponse) {
                data = await response.json()
            } else {
                data = await response.text()
            }

            return {
                data: JSON.parse(JSON.stringify(data)),
                ok: response.ok,
                status: response.status,
                statusText: response.statusText,
            }
        }

        if (
            (response.status === 401 || response.status === 403) &&
            !input.toString().includes(ApiRoutes.auth.login)
        ) {
            window.location.replace(AppRoutes.login)
            await sleep(2000)
        }

        if (response.status === 401 && input.toString().includes(ApiRoutes.auth.login)) {
            const errorMessage = await response.json()

            return {
                data: errorMessage,
                ok: response.ok,
                status: response.status,
                statusText: response.statusText,
            } as FetchResponse
        }

        if (response.status >= 400 && response.status < 500) {
            return {
                data: null,
                ok: response.ok,
                status: response.status,
                statusText: response.statusText,
            } as FetchResponse
        }

        const message = await response.json()

        return {
            data: message,
            ok: response.ok,
            status: response.status,
            statusText: response.statusText,
        } as FetchResponse
    } catch (error) {
        return {
            data: {},
            ok: false,
            status: 500,
            statusText: 'Error al realizar la solicitud',
        } as FetchResponse
    }
}

export default fetchApi
